// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IEnrollmentMatrixDto } from './IEnrollmentMatrixDto';
import {
    IEnrollmentMatrixDtoFromJSON,
    IEnrollmentMatrixDtoFromJSONTyped,
    IEnrollmentMatrixDtoToJSON,
    IEnrollmentMatrixDtoToJSONTyped,
} from './IEnrollmentMatrixDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageEnrollmentMatrixDto
 */
export interface IPageEnrollmentMatrixDto {
    /**
     * 
     * @type {number}
     * @memberof IPageEnrollmentMatrixDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageEnrollmentMatrixDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageEnrollmentMatrixDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IEnrollmentMatrixDto>}
     * @memberof IPageEnrollmentMatrixDto
     */
    content?: Array<IEnrollmentMatrixDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageEnrollmentMatrixDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageEnrollmentMatrixDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageEnrollmentMatrixDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageEnrollmentMatrixDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageEnrollmentMatrixDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageEnrollmentMatrixDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageEnrollmentMatrixDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageEnrollmentMatrixDto interface.
 */
export function instanceOfIPageEnrollmentMatrixDto(value: object): value is IPageEnrollmentMatrixDto {
    return true;
}

export function IPageEnrollmentMatrixDtoFromJSON(json: any): IPageEnrollmentMatrixDto {
    return IPageEnrollmentMatrixDtoFromJSONTyped(json, false);
}

export function IPageEnrollmentMatrixDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageEnrollmentMatrixDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IEnrollmentMatrixDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageEnrollmentMatrixDtoToJSON(json: any): IPageEnrollmentMatrixDto {
    return IPageEnrollmentMatrixDtoToJSONTyped(json, false);
}

export function IPageEnrollmentMatrixDtoToJSONTyped(value?: IPageEnrollmentMatrixDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IEnrollmentMatrixDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

